<template>
  <v-app-bar
      app
    >
    <v-app-bar-nav-icon @click.stop="toggleMini"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu
      transition="slide-y-transition"
      bottom
      right
      offset-y
      class="mr-5"
      nudge-width="120"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          text
          style="height: 100%;"
        >
          <v-img src="https://www.gravatar.com/avatar/2?d=mp" width="40" height="40" class="mr-2" />
          <span>{{ user.first_name }}</span>
        </v-btn>
      </template>

      <v-list class="py-0">
        <v-subheader>{{ user.full_name }}</v-subheader>
        <!--<v-list-item link>
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
        <v-divider />
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>

export default {
  name: 'AppBar',

  data: () => ({
    
  }),
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    toggleMini: function() {
      this.$store.commit('setSetting', {name: 'navMini', value: !this.$store.getters.setting('navMini')});
    },
    logout: function() {
      this.$store.dispatch('logoutUser');
    }
  }
};
</script>
